import * as React from 'react'
import { Link } from 'react-router-dom'

import UIMessages from '../../../../utils/ui-messages'
import { BALANCE_TYPES } from '../../../../constants/wallet'
import { priceValueMask } from '../../../../utils/mask'

export interface IWalletBalanceProps {
  actionUrl: string
  balance: number
  balanceType: BALANCE_TYPES
  riderId: string
}

interface IWalletBalanceState {}

export default class WalletBalance extends React.Component<IWalletBalanceProps, IWalletBalanceState> {
  public static defaultProps = {
    balance: 0
  }

  public render() {
    const { balance } = this.props

    return (
      <React.Fragment>
        <div className='h5'>{priceValueMask(balance)}</div>
        {this.renderAddLink()}
      </React.Fragment>
    )
  }

  private renderAddLink = () => {
    switch (this.props.balanceType) {
      case BALANCE_TYPES.OVERALL:
      case BALANCE_TYPES.WALLET: {
        return (
          <Link to={this.props.actionUrl}>
            <div title={UIMessages.common.addFunds} className='h6 font-green weight-400'>
              + {UIMessages.common.addFunds}
            </div>
          </Link>
        )
      }
      case BALANCE_TYPES.BONUS:
      default: {
        return
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/WalletBalance.tsx